export default "__VITE_ASSET__BjcM9hVb__"